var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.656 0h19.688c.362 0 .656.199.656.444v.889c0 .245-.294.444-.656.444H.656C.294 1.777 0 1.578 0 1.333V.444C0 .2.294 0 .656 0zM.375 6.49h20.25c.207 0 .375.2.375.445v.889c0 .245-.168.444-.375.444H.375c-.207 0-.375-.2-.375-.444v-.889c0-.245.168-.444.375-.444z",
    clipRule: "evenodd"
  })));
}

export default SvgHamburger;